module.exports = __webpack_public_path__ + "static/img/zhibaozhan.b8a4501e.png";